import {
    deletePromoterVideo,
    getPromoterVideos,
    updatePromoterVideo,
    uploadPromoterVideo
} from "../../helpers/promoterVideoService";
import {checkError, closeAlert, receiveErrorAlert, receiveSuccessAlert} from "../commonsActions";

export const FETCH_PROMOTER_VIDEOS_BEGIN = 'FETCH_PROMOTER_VIDEOS_BEGIN';
export const FETCH_PROMOTER_VIDEOS_SUCCESS = 'FETCH_PROMOTER_VIDEOS_SUCCESS';
export const FETCH_PROMOTER_VIDEOS_ERROR = 'FETCH_PROMOTER_VIDEOS_ERROR';

/*
 * action creators
 */

const fetchPromoterVideosSuccess = res => ({
    type: FETCH_PROMOTER_VIDEOS_SUCCESS,
    payload: {
        promoterVideos: res.data,
        numberOfElements: res.numberOfElements,
        totalElements: res.totalElements,
        totalPages: res.totalPages
    }
});

const fetchPromoterVideosError = error => ({
    type: FETCH_PROMOTER_VIDEOS_ERROR,
    payload: {
        error: error,
    }
});

export const fetchPromoterVideos = query => dispatch => {
    dispatch({type: FETCH_PROMOTER_VIDEOS_BEGIN});
    return getPromoterVideos(query).then(res => {
        dispatch(fetchPromoterVideosSuccess(res));
        return res;
    }, error => {
        dispatch(fetchPromoterVideosError(error))
        dispatch(checkError(error));
        dispatch(receiveErrorAlert(error));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
    })
};

export const saveNewPromoterVideo = video => dispatch => {
    const data = new FormData();
    data.append('companyId', video.companyId);
    data.append('categoryId', video.categoryId);
    data.append('sectionId', video.sectionId);
    data.append('tags', video.tags);
    data.append('playOnFaceDetect', video.playOnFaceDetect);
    if (video.playbackSettings) {
        data.append('playbackSettings.turnOnTime', video.playbackSettings.turnOnTime);
        data.append('playbackSettings.turnOffTime', video.playbackSettings.turnOffTime);
        data.append('playbackSettings.minutesBetweenPlays', video.playbackSettings.minutesBetweenPlays);
    }
    data.append('name', video.file.name);
    data.append('file', video.file);
    return uploadPromoterVideo(data).then(res => {
        dispatch(receiveSuccessAlert('Success'));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
        return res;
    })
};

export const updateSinglePromoterVideo = video => dispatch => {
    return updatePromoterVideo(video).then(res => {
        dispatch(receiveSuccessAlert('Update Successful'));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
        return res;
    })
};

export const removePromoterVideo = videoId => dispatch => {
    return deletePromoterVideo(videoId).then(res => {
        return res;
    }, error => {
        dispatch(checkError(error));
        dispatch(receiveErrorAlert(error));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
    })
};


// WEBPACK FOOTER //
// ./src/actions/promoter/promoterVideoActions.js